import { Button, Stack, Typography } from "@mui/material";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ROWS_PER_PAGE } from "src/constants/rowPerPage";
import ProductLaunchGraph from "src/components/ProductLaunchGraph";
import { useClinician } from "src/context/SessionProvider/ClinicianProvider";

const Organization = () => {
  const navigate = useNavigate();

  const operations = useClinician((clinician) =>
    clinician.roles.some((role) => role.name === "Operations"),
  );

  const developer = useClinician((clinician) =>
    clinician.roles.some((role) => role.name === "Developer"),
  );

  const canManageOptions = useMemo(
    () => developer || operations,
    [developer, operations],
  );

  const handleEmployees = useCallback(() => {
    navigate(`employees?p=0&l=${ROWS_PER_PAGE[0]}`);
  }, [navigate]);

  const handleProducts = useCallback(() => {
    navigate(`products?p=0&l=${ROWS_PER_PAGE[0]}`);
  }, [navigate]);

  const handleQuestions = useCallback(() => {
    navigate(`questions?p=0&l=${ROWS_PER_PAGE[0]}`);
  }, [navigate]);

  const handleQuestionOptions = useCallback(() => {
    navigate(`question-options?p=0&l=${ROWS_PER_PAGE[0]}`);
  }, [navigate]);

  const handleExperiments = useCallback(() => {
    navigate(`experiments?p=0&l=${ROWS_PER_PAGE[0]}`);
  }, [navigate]);

  const handleProviderAvailability = useCallback(() => {
    navigate(`provider-availability?p=0&l=${ROWS_PER_PAGE[0]}`);
  }, [navigate]);

  return (
    <Stack gap={2}>
      <Typography variant="h4" fontWeight={600}>
        Organization
      </Typography>
      <Stack direction="row" gap={2}>
        {canManageOptions ? (
          <>
            <Button onClick={handleEmployees}>Employees</Button>
            <Button onClick={handleProducts}>Products</Button>
            <Button onClick={handleQuestions}>Questions</Button>
            <Button onClick={handleQuestionOptions}>Question Options</Button>
            <Button onClick={handleExperiments}>Experiments</Button>
            <Button onClick={handleProviderAvailability}>
              Provider Availability
            </Button>
          </>
        ) : null}
      </Stack>
      {canManageOptions ? <ProductLaunchGraph /> : null}
    </Stack>
  );
};

export default Organization;
